const MarchMadnessGuide = (props) => {
  return (
    <svg {...props} viewBox="0 0 24 25">
      <g clipPath="url(#clip0_2709_1415)">
        <path
          d="M18 11.0596H22C21.8377 9.59803 21.2889 8.24122 20.4589 7.05957C19.1545 8.05957 18.2563 9.46643 18 11.0596Z"
          fill={props?.color || "black"}
        />
        <path
          d="M18 13.0596C18.2563 14.6527 19.1545 16.0596 20.4589 17.0596C21.2889 15.877 21.8377 14.5211 22 13.0596H18Z"
          fill={props?.color || "black"}
        />
        <path
          d="M13 11.0596H15.9465C16.1989 8.68713 17.3326 6.58723 19 5.12796C17.454 3.43738 15.3541 2.30295 13 2.05957V11.0596Z"
          fill={props?.color || "black"}
        />
        <path
          d="M8.05346 11.0596H11V2.05957C8.64585 2.30295 6.54599 3.43738 5 5.12896C6.66736 6.58723 7.80109 8.68713 8.05346 11.0596Z"
          fill={props?.color || "black"}
        />
        <path
          d="M2 13.0596C2.16227 14.5211 2.71111 15.8779 3.54109 17.0596C4.84548 16.0596 5.74367 14.6527 6 13.0596H2Z"
          fill={props?.color || "black"}
        />
        <path
          d="M3.54109 7.05957C2.71111 8.24122 2.16227 9.59803 2 11.0596H6C5.74367 9.46643 4.84548 8.05957 3.54109 7.05957Z"
          fill={props?.color || "black"}
        />
        <path
          d="M15.9465 13.0596H13V22.0596C15.3541 21.8152 17.454 20.6818 19 18.9912C17.3336 17.5319 16.1989 15.433 15.9465 13.0596Z"
          fill={props?.color || "black"}
        />
        <path
          d="M11 13.0596H8.05346C7.80109 15.433 6.66736 17.5319 5 18.9912C6.54599 20.6818 8.64585 21.8162 11 22.0596V13.0596Z"
          fill={props?.color || "black"}
        />
      </g>
      <defs>
        <clipPath id="clip0_2709_1415">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.0595703)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default MarchMadnessGuide;
